import ConfigFile from "../../../datasets/config_file";
import { calcInflationAmt } from "../../../objects/CommonUse/calc_inflation_amt";
import calcRandomNumberWithMax from "../../../objects/CommonUse/calc_random_number_with_max";

export const setLevelLivingExpenses = (selectedActivity, nbrMonthsPlayed) => {
    let baseLineExpenses = ConfigFile.gameBoard.baseLineExpenses;
    let annualBaseLine = baseLineExpenses * 12;
    let nbrYearsInGame = (nbrMonthsPlayed / 12).toFixed(0);
    let inflatedAnnualBaseLine = calcInflationAmt(annualBaseLine, nbrYearsInGame);
    let monthlyBaseLine = (inflatedAnnualBaseLine / 12).toFixed(2);
    let baselineMultiplier = 1;
    let additionalMoodPoints = 2;
    switch (selectedActivity) {
        case 4:
            baselineMultiplier = 1.5;
            additionalMoodPoints = 8;
            break;
        case 3: 
            baselineMultiplier = 1.25;
            additionalMoodPoints = 4;
            break;
        case 2:
            baselineMultiplier = 1.00;
            additionalMoodPoints = 0;
            break;
        case 1:
            baselineMultiplier = .75;
            additionalMoodPoints = -4;
            break;
        default:
            break;
    }
    let randomAmount = calcRandomNumberWithMax(50);
    const estimatedMonthlyExp = ((monthlyBaseLine * baselineMultiplier) + randomAmount).toString();
    const returnObj={estimatedMonthlyExp: estimatedMonthlyExp, additionalMoodPoints: additionalMoodPoints}
    return returnObj;
}
export default setLevelLivingExpenses